"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunnelControlEnabledRedirection = void 0;

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _utilities2 = require("../ButtonWrapper/utilities");

var _constant = require("../constant");

var _utils = require("../utils");

var getFunnelControlEnabledRedirection = function getFunnelControlEnabledRedirection(tripType, tripDates, destination, passengers, promoCode, showTravelClass, showFswCabinClass, travelClass, currency, geoid, locale, isMobile, unifiedListingConfig, operatingAirline, origin, environment, domain, cityLevelGrouping, isEdit) {
  var channelId = isMobile ? _constant.CHANNEL_HASH.mobileWeb : _constant.CHANNEL_HASH.web;
  var headers = {
    'Content-Type': 'application/json',
    channel_hash: channelId,
    'Ga-Id': _utilities.default.getCookie('__airasiaga')
  };

  if (isEdit) {
    headers['Search-Pre-Fetch'] = 'false';
  }

  var funnelData = (0, _utilities2.constructFunnelData)(tripType, tripDates, destination, passengers, promoCode, showTravelClass, showFswCabinClass, travelClass, currency, geoid, locale, isMobile, unifiedListingConfig, operatingAirline, origin, cityLevelGrouping);
  var url = (0, _utils.formatEndpointURL)('{funnel_control_url}/v1/redirectionurls', environment, domain);
  return (0, _utilities2.fetchData)(url, headers, funnelData);
};

exports.getFunnelControlEnabledRedirection = getFunnelControlEnabledRedirection;